import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=4305576a&scoped=true"
import script from "./Chart.vue?vue&type=script&setup=true&lang=js"
export * from "./Chart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Chart.vue?vue&type=style&index=0&id=4305576a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4305576a",
  null
  
)

export default component.exports